import React from "react";

const ThreeStars = (props) => {
  return <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14.667"
    height="14.667"
    fill="none"
    viewBox="0 0 14.667 14.667"
    {...props}
  >
    <g clipPath="url(#clip0_310_2294)" transform="translate(-.667 -.666)">
      <path
        fill="url(#paint0_linear_310_2294)"
        d="M12.667 6l.833-1.834 1.834-.833L13.5 2.5 12.667.667 11.834 2.5 10 3.333l1.834.833zm-5 .333L6 2.666 4.334 6.333.667 8l3.667 1.667L6 13.333l1.667-3.666L11.334 8zm5 3.667l-.833 1.833-1.834.834 1.834.833.833 1.833.833-1.833 1.834-.833-1.834-.834z"
      ></path>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_310_2294"
        x1="0.667"
        x2="15.333"
        y1="8"
        y2="8"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.473" stopColor="#BCC6FE"></stop>
        <stop offset="1" stopColor="#A6DEFF"></stop>
      </linearGradient>
      <clipPath id="clip0_310_2294">
        <path fill="#fff" d="M0 0H16V16H0z"></path>
      </clipPath>
    </defs>
  </svg>
}

export default ThreeStars;